import React, { ReactNode } from "react";

interface Props {
  children: ReactNode;
}

export default function ModalBlankCenterPanel({ children }: Props): JSX.Element {
  return (
    <div
      className="max-w-[75%] inline-block text-center align-middle rounded-none transform transition-all"
      role="dialog"
      aria-modal="true"
      aria-labelledby="modal-headline"
    >
      {children}
    </div>
  );
}
